var map = {
	"./card.svg": "ff3c",
	"./cash.svg": "6c9c",
	"./courier.svg": "aa6a",
	"./drink.svg": "6f47",
	"./half.svg": "1c2d",
	"./pay.svg": "fcac",
	"./phone.svg": "8c07",
	"./pickup.svg": "de69",
	"./pickup7.svg": "0db4",
	"./sauce.svg": "c970",
	"./tel.svg": "a4e7",
	"./time.svg": "1934",
	"./web.svg": "3b91"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d839";